var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b({ staticClass: "modal-container" }, "div", _vm.$attrs, false),
      _vm.$listeners
    ),
    [
      _c("portal-target", {
        attrs: { name: "modal-container" },
        on: { change: _vm.handle_update },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }